module.exports = __webpack_public_path__ + "d8b29be326c127ee545284ba13ccca08.svg";